import * as React from 'react'; 
import { Translation } from '../../../models/models';


export interface PortraitViewProps{
    className?:string;
    locale?:Translation;
}

export interface PortraitViewState{

}

export class PortraitView extends React.Component<PortraitViewProps, PortraitViewState>{
    el:HTMLDivElement;
    constructor(p:PortraitViewProps){
        super(p);
    }

    render(){
        let {props, state} = this,
            cls = this.props.className || "";
        return (
            <div className={"portrait-view " + cls} ref={e=> this.el= e}>

            <img  className="mobile-logo"  alt="The UK Domain - Helping businesses achieve more online" src="img/campaign-logo.png" />
            <div  className="portrait-view__splash-info">
                  <p>{this.props.locale.rotateInfo}</p>
                  <i className="icon-patent-icon-mobile" />
                </div>
                
            </div>
        )
    }
}